import {
  registerApplication,
  start,
  addErrorHandler,
  getAppStatus,
  LOAD_ERROR,
} from 'single-spa';
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from 'single-spa-layout';
import { datadogRum } from '@datadog/browser-rum';
import { dataDogConfig, UNLEASH_FEATURE_FLAGS } from './utils/constants';
import sessionLifecycle, {
  client as unleashClient,
} from './auth/sessionLifecycle';
import { authUtils } from './utils/authEvents';
// import * as FullStory from '@fullstory/browser';
import { keycloakSessionLifecycle } from './auth/keycloakSessionLifecycle';
import handleBreadcrumbs from './utils/breadcrumb-handler';

const selectSessionLifecycle = async datadogRum => {
  await unleashClient.start();
  const keycloak_sso = unleashClient.isEnabled(
    UNLEASH_FEATURE_FLAGS.KEYCLOAK_SSO
  );

  if (keycloak_sso) {
    keycloakSessionLifecycle();
    window.authUtils = authUtils;
  } else {
    sessionLifecycle(datadogRum);
  }
};

const copilotRootConfig = () => {
  const routes = constructRoutes(document.querySelector('#single-spa-layout'));
  const applications = constructApplications({
    routes,
    loadApp({ name }) {
      return System.import(name);
    },
  });
  const layoutEngine = constructLayoutEngine({ routes, applications });
  // const fullStoryOrgId = process.env.FULLSTORY_ORG_ID;

  applications.forEach(registerApplication);
  layoutEngine.activate();
  datadogRum.init(dataDogConfig);
  // if (!isEURegion && fullStoryOrgId) {
  //   FullStory.init({ orgId: process.env.FULLSTORY_ORG_ID });
  // }
  datadogRum.startSessionReplayRecording();
  addErrorHandler(err => {
    if (getAppStatus(err.appOrParcelName) === LOAD_ERROR) {
      System.delete(System.resolve(err.appOrParcelName));
    }
  });

  selectSessionLifecycle(datadogRum);

  handleBreadcrumbs();
  start();
};

export default copilotRootConfig;
